import { Link } from '@/navigation';
import React from 'react';
import Heading, {
  HeadingTag,
  HeadingSize,
} from '@/components/ui/Heading/Heading';

interface NotFoundProps {
  href?: string;
}
const NotFound = ({ href = '/' }: NotFoundProps) => {
  return (
    <div className="grid h-[100vh] place-content-center bg-white px-4">
      <div className="h-auto text-center">
        <Heading
          tag={HeadingTag.H1}
          size={HeadingSize.H1}
          classes="font-black text-charcoal-v2"
          text="404"
          hoverEffect
        />
        <p className="text-2xl font-bold tracking-tight text-charcoal-v2 sm:text-4xl">
          Oh no!
        </p>
        <div className="m-4 text-gray-500">We can't find that page.</div>
        <div className="relative">
          <Link href={href} className="btn-responsive btn-primary btn">
            Go back home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default React.memo(NotFound);
